jQuery(function($) {
  let $beforeAfterSlider = $('[data-component="image-comparison-slider"]');
  if ($beforeAfterSlider.length === 0) {
      return;
  }

  // Function to set the slider state
  function setSliderstate(e, element) {
      const sliderRange = element.querySelector('[data-image-comparison-range]');
      if (e.type === 'input') {
          sliderRange.classList.add('image-comparison__range--active');
          return;
      }

      sliderRange.classList.remove('image-comparison__range--active');
  }

  // Function to move the slider range
  function moveSliderRange(e, element) {
      const value = e.target.value;
      const slider = element.querySelector('[data-image-comparison-slider]');
      const imageWrapperOverlay = element.querySelector('[data-image-comparison-overlay]');

      slider.style.left = `${value}%`;
      imageWrapperOverlay.style.width = `${value}%`;

      setSliderstate(e, element);
  }

  // Function to initialize each slider
  function init(element) {
      const sliderRange = element.querySelector('[data-image-comparison-range]');

      if ('ontouchstart' in window === false) {
          sliderRange.addEventListener('mouseup', (e) => setSliderstate(e, element));
      }

      sliderRange.addEventListener('input', (e) => moveSliderRange(e, element));
      sliderRange.addEventListener('change', (e) => moveSliderRange(e, element));
  }

  // Initialize each instance of the image comparison slider
  $beforeAfterSlider.each(function() {
      init(this);
  });
});
